import { render, staticRenderFns } from "./modal-confirmation-discard-photo.vue?vue&type=template&id=d334881a&scoped=true"
import script from "./modal-confirmation-discard-photo.vue?vue&type=script&lang=js"
export * from "./modal-confirmation-discard-photo.vue?vue&type=script&lang=js"
import style0 from "./modal-confirmation-discard-photo.vue?vue&type=style&index=0&id=d334881a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d334881a",
  null
  
)

export default component.exports